import React from 'react'
import { IconButton } from '@mui/material'

interface DesktopArrowProps {
    direction: 'left' | 'right'
    onClick: () => void
    children: React.ReactNode
}

const DesktopArrow: React.FC<DesktopArrowProps> = ({ direction, onClick, children }) => (
    <IconButton
        onClick={onClick}
        sx={{
            position: 'absolute',
            [direction]: -60,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 20,
            width: 48,
            height: 48
        }}
    >
        {children}
    </IconButton>
)

export default DesktopArrow

